import React from "react";
import { NakiMobileHomeSectionListTemplate } from "themes/administration/naki-mobile/pages";
import { NakiMobileHandheldPinkHomeSectionListViewStore } from "administration/naki-mobile/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new NakiMobileHandheldPinkHomeSectionListViewStore(rootStore, componentProps),
    "nakiMobileHomeSectionListViewStore"
)
class NakiMobileHandheldPinkHomeSectionList extends React.Component {
    render() {
        return <NakiMobileHomeSectionListTemplate {...this.props} />;
    }
}

export default NakiMobileHandheldPinkHomeSectionList;
